export default __webpack_public_path__ + "static/amenagement-perron-d46871105930da0ede98a9f49b3fea7a.png";